module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0025.jpg?v=7bd310bf";